export enum PlanItemIds {
    PRO_MONTHLY = 'AOT-Pro-Tier-USD-Monthly',
    PRO_YEARLY = 'AOT-Pro-Tier-USD-Yearly',
    STANDARD_MONTHLY = 'Standard-Tier-USD-Monthly',
    STANDARD_YEARLY = 'Standard-Tier-USD-Yearly',
    FREE_TIER_MONTHLY = 'AOT-Free-Tier-USD-Monthly',
    FREE_TIER_YEARLY = 'AOT-Free-Tier-USD-Yearly'
}

export enum AddOnItemIds {
    LOCATION_MONTHLY = 'Additional-Location-USD-Monthly',
    STAFF_MONTHLY = 'Additional-Staff-USD-Monthly',
    APPNTMNT_MONTHLY = '1000-Appointment-Pack-USD-Monthly',
}

export enum TenantSubscriptionStatus {
    ACTIVE = "ACTIVE",
    CANCELLED = "CANCELLED",
    FUTURE = "FUTURE",
    IN_TRIAL = "IN_TRIAL",
    NON_RENEWING = "NON_RENEWING",
    PAUSED = "PAUSED"
}

export enum SubscriptionStatus {
    ACTIVE = "active",
    CANCELLED = "cancelled",
    FUTURE = "future",
    IN_TRIAL = "in_trial",
    NON_RENEWING = "non_renewing",
    PAUSED = "paused"
}

export type SubscriptionDto = {
    billing_period: number
    subscription_items: SubscriptionItemDto[],
    has_scheduled_changes: boolean
    due_invoices_count: number
    exchange_rate: number
    billing_period_unit: string
    channel: string
    mrr: number
    currency_code: string
    deleted: boolean
    auto_collection: string
    id: string
    customer_id: string
    next_billing_at: number
    base_currency_code: string
    status: SubscriptionStatus
    object: string
}

export type SubscriptionItemDto = {
    item_price_id: string
    item_type: string
    quantity: number
    free_quantity: number
    unit_price: number
    amount: number
    amount_in_decimal: string
}

export type SubscriptionItemPriceDto = {
    currency_code: string
    description: string
    free_quantity: number
    id: string
    is_taxable: boolean
    item_family_id: string
    item_id: string
    item_type: string
    name: string
    object: string
    period: number
    period_unit: string
    price: number
    pricing_model: string
    status: string
}

export type ChargebeeSubscriptionDto = {
    mandatoryItemsToRemove?: string[]
    subscriptionItems: ChargebeeSubscriptionItemDto[]
    replaceItemsList?: boolean,
    endOfTerm?: boolean,
    changeOption?: string,
    invoiceImmediately?: boolean,
    prorate?: boolean
}

export type ChargebeeSubscriptionItemDto = {
    subscriptionItemItemPriceId?: string
    subscriptionItemQuantity: number
    subscriptionItemUnitPrice: number
    period?: number
    period_unit?: string
    type?: string
}

export type CouponDto = {
    apply_on: string
    discount_amount: number
    discount_percentage: number
    discount_type: string
    invoice_name: string
    apply_discount_on: string
    name: string
    id: string
    status: string
}

export type Subscription = {
    plan: SubscriptionItemDto
    location_add_on: SubscriptionItemDto
    staff_add_on: SubscriptionItemDto
    appointment_add_on: SubscriptionItemDto
}